/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import { useI18n } from "hooks/i18n/i18n";
import React from "react";
import { changeStyleWithHosting } from "utility/hosting";

import type { i18nStringType } from "i18n/i18nString";

type AccountLotteryStatusType = "inProgress" | "won" | "lost";

type Props = {
  status: AccountLotteryStatusType;
};

const STATUS_I18N_KEYS: Record<AccountLotteryStatusType, i18nStringType> = {
  inProgress: "account.history.entryInProgress",
  lost: "account.history.lost",
  won: "account.history.won",
};

export const AccountLotteryStatus: React.FC<Props> = ({ status }) => {
  const { t } = useI18n();
  const classes = styles({ status });

  return <span css={classes.status}>{t(STATUS_I18N_KEYS[status])}</span>;
};

const styles = ({ status }: Props) => {
  const { accentColor } = changeStyleWithHosting().baseStyles;
  const statusColors: Record<
    AccountLotteryStatusType,
    { backgroundColor: string; borderColor: string; color: string }
  > = {
    inProgress: {
      color: accentColor,
      backgroundColor: "transparent",
      borderColor: accentColor,
    },
    lost: {
      color: "#666",
      backgroundColor: "#f1f1f1",
      borderColor: "#f1f1f1",
    },
    won: {
      color: "#fff",
      backgroundColor: "#d9368d",
      borderColor: "#d9368d",
    },
  };
  const colors = statusColors[status];

  return {
    status: css({
      display: "inline-block",
      minWidth: "94px",
      padding: "4px 12px",
      marginBottom: "6px",
      color: colors.color,
      fontSize: "12px",
      fontWeight: "bold",
      lineHeight: 1,
      textAlign: "center",
      backgroundColor: colors.backgroundColor,
      border: `2px solid ${colors.borderColor}`,
      borderRadius: "4px",
    }),
  };
};
